var moment = require('moment');
var _ = require('lodash');

module.exports = function(ev) {
    if (!ev) return;
    if (ev.isLive) return ev;

    ev = { ...ev };

    ev.isLive = function() {
        return this.statusType === 'inprogress';
    };
    ev.isComming = function() {
        return this.statusType === 'notstarted';
    };
    ev.isComing = function() {
        return this.statusType === 'notstarted';
    };
    ev.isFinished = function() {
        return this.statusType === 'finished';
    };
    ev.isFT = ev.isFinished;

    ev.isCancelled = function() {
        return this.statusType === 'cancelled';
    };
    ev.isPostponed = function() {
        return this.statusFull === 'Postponed';
    };
    ev.isHT = function() {
        return this.statusFull === 'Halftime';
    };
    ev.isFirstHalf = function() {
        return this.statusFull === '1st half';
    };
    ev.isSecondHalf = function() {
        return this.statusFull === '2nd half';
    };
    ev.isFirstExtra = function() {
        return this.statusFull === 'Extra Time - 1st half';
    };
    ev.isSecondExtra = function() {
        return this.statusFull === 'Extra Time - 2nd half';
    };
    ev.isPenalty = function() {
        return this.statusFull === 'Penalty';
    };
    ev.isFinishedAP = function() {
        return this.statusFull === 'Finished AP';
    };
    ev.isFinishedAET = function() {
        return this.statusFull === 'Finished AET';
    };
    ev.isWaitingForPenalty = function() {
        return this.statusFull === 'Waiting for Penalty';
    };
    ev.isWaitingForET = function() {
        return this.statusFull === 'Waiting for extra time';
    };
    ev.getCurrentMin = function() {
        return 10;
    };
    ev.getStatusShort = function() {
        if (this.isComing()) return moment(this.startDate).format('HH:mm');
        if (this.isHT()) return 'HT';
        if (this.isLive()) return this.getMinutes();
        if (this.isCancelled()) return 'CAN';
        if (this.isFinished()) return 'FT';
        return '';
    };

    ev.getStartDate = function() {
        return moment(+moment.utc(this.startDate));
    };
    ev.getPureMinutes = function() {
        if (this.isComming()) return 0;
        if (this.isFinishedAP()) return 120;
        if (this.isFinishedAET()) return 120;
        if (this.isFinished()) return 90;

        // pauses
        if (this.isHT()) return 45;
        if (this.isWaitingForET()) return 90;
        if (this.isWaitingForPenalty()) return 120;

        var ms = moment().unix() - this.getStartDate().unix();

        var mins = this.msToMin(ms) + 1;

        if (this.isFirstHalf()) {
            return Math.min(mins, 45);
        } else if (this.isSecondHalf()) {
            return Math.min(mins - 15, 90);
        } else if (this.isWaitingForET()) {
            return Math.min(mins - 15, 90);
        } else if (this.isFirstExtra()) {
            // TODO ADD COEF
            return Math.min(mins - 15, 120);
        } else if (this.isSecondExtra()) {
            // TODO ADD COEF
            return Math.min(mins - 15, 120);
        }

        // TODO implement EXTRA TIME + PENALTY SHOOTOUT

        return mins;
    };
    ev.msToMin = function(ms) {
        return Math.round(ms / 60);
    };

    ev.getMatchLength = function() {
        if (this.sportId === 5) {
            //hockey
            return 60 * 60;
        }
        if (this.sportId === 1) {
            if (this.isFinishedAET() || this.isFinishedAP()) return 120; //
            if (
                this.isFirstExtra() ||
                this.isSecondExtra() ||
                this.isPenalty() ||
                this.isWaitingForET() ||
                this.isWaitingForPenalty()
            )
                return 120;

            return 90;
        }
    };

    ev.getLivePeriod = function() {
        if (this.detailedScore.extratime) return 4;
        if (this.detailedScore.period3) return 3;
        if (this.detailedScore.period2) return 2;
        if (this.detailedScore.period1) return 1;
        return 1;
    };
    ev.getPeriodStatus = function(period) {
        if (this.isFinished()) return 'finished';
        if (this.isComming() || this.isCancelled()) return 'notstarted';
        if (this.isLive()) {
            if (this.getLivePeriod() < period) return 'notstarted';
            if (this.getLivePeriod() === period) return 'live';
            if (this.getLivePeriod() > period) return 'finished';
        }
    };

    ev.getProperties = function() {
        return this.properties || {};
    };

    ev.getGameStarted = function() {
        if (this.getProperties().gameStarted) {
            return moment.utc(this.getProperties().gameStarted);
        }
        return null;
    };
    ev.getSecondHalfStarted = function() {
        if (this.getProperties().secondHalfStarted) {
            return moment.utc(this.getProperties().secondHalfStarted);
        }
        return null;
    };
    ev.getSecondHalfEnded = function() {
        if (this.getProperties().secondHalfEnded) {
            return moment.utc(this.getProperties().secondHalfEnded);
        }
        return null;
    };
    ev.hasOT = function() {
        return this.detailedScore && this.detailedScore.extratime;
    };
    ev.hasBullittes = function() {
        return this.detailedScore && this.detailedScore.penaltyshootout;
    };
    ev.getGoalsIncidents = function(isHome) {
        var teamId = isHome ? this.homeId : this.awayId;

        var goalIds = [7, 8, 10, 12, 18, 28];

        var incidents = _.filter(this.incidents, function(inc) {
            return teamId === inc.teamId && goalIds.indexOf(inc.typeId) !== -1;
        });
        return incidents;
    };
    ev.getRichIncidents = function() {
        var incidents = [];
        _.each(this.incidents, function(i) {
            incidents.push(_.clone(i)); // avoid firing events when change incidents
        });

        var stripped = _.filter(incidents, function(i) {
            return i.typeId !== 20;
        }); // remove sub_out

        _.chain(stripped)
            .where({ typeId: 32 })
            .each(function(i) {
                i.related = _.where(incidents, { typeId: 20, home: i.home, min: i.min })[0];
            });

        return stripped;
    };
    ev.getMinutes = function() {
        if (this.eventId < 100) {
            if (ev.isFinished()) {
                return ev.getMatchLength();
            }
            var inc = _.last(ev.incidents);
            if (inc) return inc.min;
        }

        if (this.isFirstHalf() && this.getGameStarted()) {
            const ms = moment().unix() - this.getGameStarted().unix();
            return Math.min(this.msToMin(ms) + 1, 45);
        } else if (this.isSecondHalf() && this.getSecondHalfStarted() !== null) {
            const ms = moment().unix() - this.getSecondHalfStarted().unix();
            return Math.min(this.msToMin(ms) + 1 + 45, 90);
        } else if (this.isFirstExtra() && this.getSecondHalfEnded() !== null) {
            // subtract time from end of second half time
            // TODO ADD RANDOM TIME SHIFT FOR TIMES DELAY
            const ms = moment().unix() - this.getSecondHalfEnded().unix();
            return Math.min(this.msToMin(ms) + 1 + 90, 120);
        } else if (this.isSecondExtra() || this.isPenalty() /* && this.getSecondHalfEnded() != null*/) {
            // subtract time from end of second half time
            // TODO ADD RANDOM TIME SHIFT FOR TIMES DELAY
            const ms = moment().unix() - this.getSecondHalfEnded().unix();
            return Math.min(this.msToMin(ms) + 1 + 90, 120);
        } else {
            return this.getPureMinutes();
        }
    };

    ev.shouldBeLive = function() {
        if (ev.isFinished()) return false;
        const difference = moment().diff(moment(ev.startDate), 'minutes');
        return difference >= -60;
    };

    ev.getShortHomeName = function() {
        return this.homeShortName || this.homeName.substring(0, 3).toUpperCase();
    };

    ev.getShortAwayName = function() {
        return this.awayShortName || this.awayName.substring(0, 3).toUpperCase();
    };
    ev.shortName = function() {
        return this.getShortHomeName() + '-' + this.getShortAwayName();
    };

    return ev;
};



/** WEBPACK FOOTER **
 ** ../src/widgets/helpers/Eventify.js
 **/